import React from 'react';
import { XIcon } from '@heroicons/react/solid';

export const SelectedItemButton = ({ name, onClick }) => {
  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type="button"
      onClick={onClick}
      className={`flex text-sm ${onClick ? 'cursor-pointer' : 'cursor-default'}`}
    >
      {!!onClick && (
      <div>
        <XIcon className="h-5 w-5 mr-2 text-indigo-500" aria-hidden="true" />
      </div>
      )}
      <div className="text-left font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
        {name}
      </div>
    </button>
  );
};
